<template>
  <div class="vuestic-file-upload"
       :class="{'vuestic-file-upload--dropzone': dropzone}">
    <vuestic-file-upload-container :type="type"
                                   :fileTypes="fileTypes"
                                   :dropzone="dropzone"
                                   @upload="uploadFile"
                                   :disabled="disabled">
      <vuestic-file-upload-list v-if="files.length"
                                :type="type"
                                :files="files"
                                @remove="removeFile"
                                @remove-single="removeSingleFile"
                                :disabled="disabled" />
      <vuestic-modal ref="mediumModal"
                     :no-buttons="true">
        <div slot="title">{{ $t('fileUpload.modalTitle') }}</div>
        <div>
          {{ $t('fileUpload.modalText') }}
        </div>
      </vuestic-modal>
    </vuestic-file-upload-container>
  </div>
</template>

<script>
import VuesticFileUploadList from './VuesticFileUploadList'
import VuesticFileUploadContainer from './VuesticFileUploadContainer'
import mixin from '../../../components/MerchantKYC/mixins/mixin'

export default {
  name: 'vuestic-file-upload-kyc',
  mixins: [mixin],
  components: {
    VuesticFileUploadList: VuesticFileUploadList,
    VuesticFileUploadContainer: VuesticFileUploadContainer,
  },
  props: {
    type: {
      type: String,
      default: 'list',
      validator: function (value) {
        return ['list', 'gallery', 'single'].indexOf(value) !== -1
      },
    },
    fileTypes: {
      type: String,
      default: '',
    },
    dropzone: {
      type: Boolean,
      default: false,
    },
    value: {
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    uploadFile (e) {
      let files = e.target.files || e.dataTransfer.files
      // type validation
      if (this.fileTypes) {
        files = this.validateFileTypes(files)
      }
      let that = this
      this.kycUploadFiles(files, (images) => {
        that.files = [...images, ...that.files]
      })
    },
    removeFile (index) {
      let deleteFile = this.files.splice(index, 1)
      this.$emit('removeFile', deleteFile[0])
    },
    removeSingleFile () {
      this.files = []
    },
    validateFileTypes (files) {
      return [...files].filter((file) => {
        const fileName = file.name
        const extn = fileName
          .substring(fileName.lastIndexOf('.') + 1)
          .toLowerCase()
        if (this.fileTypes.indexOf(extn) === -1) {
          this.$refs.mediumModal.open()
        }
        return this.fileTypes.indexOf(extn) !== -1
      })
    },
    // filterCommonName (files) {
    //   if (files.length === 0) return
    //   let hash = {}
    //   files = files.reduceRight((item, next) => {
    //     hash[next.name] ? '' : (hash[next.name] = true && item.push(next))
    //     return item
    //   }, [])
    //   return files.reverse()
    // }
  },
  computed: {
    files: {
      get () {
        return this.value
      },
      set (files) {
        let that = this
        // 过滤重名的文件
        // files = that.filterCommonName(files)
        that.$emit('input', files)
      },
    },
  },
}
</script>

<style lang='scss'>
.vuestic-file-upload {
  &--dropzone {
    background-color: $lighter-green;
    padding: 0 2rem;
    overflow: hidden;
  }
}

// Maybe we should create new component for text button
.btn-text {
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  padding: 0;

  & + & {
    margin-left: 1.5rem;
  }

  &--primary {
    color: $vue-green;

    &:hover {
      opacity: 0.6;
    }
  }

  &--secondary {
    color: $white;
  }
}

@media (max-width: 576px) {
  .vuestic-file-upload {
    &--dropzone {
      padding: 0 1rem;
    }
  }
}
</style>
